import React from 'react';
import tenantConstants from '@constants';
import { useTranslation } from 'react-i18next';
import { formatNumberString } from '../../../../utility/utility';
import { getLicenseTitle, getLicenseLocation, formatIssuedAgo, formatIssuedDate } from './utils';
import { PinIcon, CalendarIcon, ChevronRightIcon } from './icons';
import {
  Row,
  Main,
  TitleRow,
  LicenseNumber,
  Chip,
  MetaRow,
  Meta,
  AvatarImage,
  AvatarFallback,
  UnassignedAvatar,
  UnassignedDash,
  MobilePrice,
  Actions,
  DesktopPrice,
  ViewDetailsButton,
  PostNowButton,
} from './ad-license-list-row.styled';

const Avatar = ({ agent }) => {
  if (agent?.profile_image) {
    return <AvatarImage src={agent.profile_image} alt="" />;
  }
  const initials = (agent?.name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();
  return <AvatarFallback>{initials}</AvatarFallback>;
};

const AdLicenseListRow = ({ row, isIndividualSeller, isMobile = false, onViewDetails, onPostNow }) => {
  const { t, i18n } = useTranslation();
  const typeTitle = getLicenseTitle(row?.property_type, row?.purpose, t);
  const location = getLicenseLocation(row?.location);
  const hasAgent = !!row?.agent;

  return (
    <Row $isMobile={isMobile}>
      <Main>
        <TitleRow>
          <LicenseNumber>{row?.ad_license_number}</LicenseNumber>
          {typeTitle ? <Chip>{typeTitle}</Chip> : null}
        </TitleRow>
        <MetaRow>
          {location ? (
            <Meta>
              <PinIcon size={13} />
              <span>{location}</span>
            </Meta>
          ) : null}
          {row?.issue_date ? (
            <Meta>
              <CalendarIcon size={13} />
              <span>
                {t('Issued {{ago}}', { ago: formatIssuedAgo(row.issue_date, i18n.language) })} · {formatIssuedDate(row.issue_date)}
              </span>
            </Meta>
          ) : null}
          {!isIndividualSeller &&
            (hasAgent ? (
              <Meta $gap={7}>
                <Avatar agent={row.agent} />
                <span>{row.agent.name}</span>
              </Meta>
            ) : (
              <Meta $gap={7} $color="rgb(157,157,157)">
                <UnassignedAvatar>
                  <UnassignedDash />
                </UnassignedAvatar>
                <span>{t('Unassigned', { context: 'adLicense' })}</span>
              </Meta>
            ))}
        </MetaRow>
      </Main>

      {isMobile && row?.price != null && (
        <MobilePrice>
          {tenantConstants.CURRENCY_SYMBOL()} {formatNumberString(row.price)}
        </MobilePrice>
      )}

      <Actions $isMobile={isMobile}>
        {!isMobile && row?.price != null && (
          <DesktopPrice>
            {tenantConstants.CURRENCY_SYMBOL()} {formatNumberString(row.price)}
          </DesktopPrice>
        )}
        <ViewDetailsButton type="button" onClick={() => onViewDetails(row)} $isMobile={isMobile}>
          {t('View More Details')}
        </ViewDetailsButton>
        <PostNowButton type="button" onClick={() => onPostNow(row)} $isMobile={isMobile}>
          <span>{t('Post Now')}</span>
          <ChevronRightIcon size={16} />
        </PostNowButton>
      </Actions>
    </Row>
  );
};

export default AdLicenseListRow;
